jQuery_T4NT(document).ready(function($) {
  
  // buton 'LA COMANDA'
  $('.nt-swatch').on('click', function(){
    setTimeout(function(){
      if($('.single_add_to_cart_button .txt_add').css('display') == 'none'){$('.single_add_to_cart_button').css('background-color','#0d3e4f');}  // <<--- culoare buton 'ADAUGA IN COS'
      else{$('.single_add_to_cart_button').css('background-color','#359181');}  // <<--- culoare buton 'LA COMANDA'
    }, 10);
    var val_size = $(this).attr('data-escape');
    //console.log('Alegere marime:'+val_size);
    (rtbhEvents = window.rtbhEvents || []).push(
      {eventType: 'size',
        size: val_size
      },
      {eventType: 'uid',
        id: 'unknown'
      });
    
  }) // ./buton 'LA COMANDA'

  $('.wishlistadd').on('click', function(){
     var val_id = $(this).attr('data-id');
     //console.log('Add wishlist:'+val_id);
     (rtbhEvents = window.rtbhEvents || []).push(
      {eventType: 'wishlist',
      offerId: val_id
      },
      {eventType: 'uid',
        id: 'unknown'
      });
  })

  // start timer
  const retrieveMondayDate = (date = new Date()) => {
    const clonedDate = new Date(date.getTime());
  
    const numOfDays = ((7 - clonedDate.getDay()) % 7 + 1) % 7;
    const newDate = clonedDate.getDate() + numOfDays;

    return clonedDate.setDate(newDate);
  };

  // day: 0=Sunday, 1=Monday...4=Thursday...
function nextDayAndTime(dayOfWeek, hour, minute) {
  var now = new Date()
  var result = new Date(
                 now.getFullYear(),
                 now.getMonth(),
                 now.getDate() + (7 + dayOfWeek - now.getDay()) % 7,
                 hour,
                 minute)

  if (result < now)
    result.setDate(result.getDate() + 7)
  
  return result
}

  
  function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  
  return {
    total,
    days,
    hours,
    minutes,
    seconds
  };
}

function initializeClock(id, endtime) {
  const clock = document.getElementById(id);
  const daysSpan = clock.querySelector('.days');
  const hoursSpan = clock.querySelector('.hours');
  const minutesSpan = clock.querySelector('.minutes');
  const secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    const t = getTimeRemaining(endtime);

    daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  const timeinterval = setInterval(updateClock, 1000);
}

const deadline = nextDayAndTime(1, 06, 0);
initializeClock('clockdiv', deadline);
// end timer



  
});